import { createReducer, createActions } from "reduxsauce";

import { insert } from "../../util/array";

const { Types, Creators } = createActions({
    registrarEstimuloCockpit: ["payload"],
    iniciarPrimeiroEstimulo: ["payload"],
    registrarEstimulo: ["payload"],
    resetCockpit
});

import { cockpit } from "../initialValues";

const INITIAL_STATE_COCKPIT = {
    Consulta: {
        "@consulta": {
            inicio: {
                momento: "",
                obj: {}
            },
            fim: {
                momento: "",
                obj: {}
            }
        },
    }
};

const registrarEstimuloCockpit = (state, { payload }) => {
    return state;
};

const registrarEstimulo = (state, { payload }) => {
    let esteira = state[payload.esteira]
    esteira[payload.type][payload.tipoExec] = {
        momento: payload.momentoExec,
        obj: payload
    }
    return { ...state, [payload.esteira]: esteira };
};

const iniciarPrimeiroEstimulo = (state, { payload }) => {
    let esteira = state[payload.esteira]
    esteira[payload.type][payload.tipoExec] = {
        momento: payload.momentoExec,
        obj: payload
    }
    return { ...state, [payload.esteira]: esteira };
};

const resetCockpit = () => {
    return cockpit;
};

export { Types as CockpitTypes };

export { Creators as cockpitActions };

export const reducer = createReducer(INITIAL_STATE_COCKPIT, {
    [Types.REGISTRAR_ESTIMULO_COCKPIT]: registrarEstimuloCockpit,
    [Types.INICIAR_PRIMEIRO_ESTIMULO]: iniciarPrimeiroEstimulo,
    [Types.REGISTRAR_ESTIMULO]: registrarEstimulo,
    [Types.RESET_COCKPIT]: resetCockpit
});
